'use strict';

/**
 * Simple GET request wrapper (for tests mainly)
 */
export default {
  fetch(url) {
    return (new window.Image()).src = url;
  }
};



// WEBPACK FOOTER //
// ./pixel/pixel.js